const getters = {
  token: state => state.user.token,
  sellerToken: state => state.user.sellerToken,
  platformToken: state => state.user.platformToken,
  avatar: state => state.user.avatar,
  userId: state => state.user.userId,
  name: state => state.user.name,
  buyParams: state => state.user.buyParams,
  shopName: state => state.user.shopName,
  shopIcon: state => state.user.shopIcon,
  shopId: state => state.user.shopId,
  mchtId: state => state.user.parentId || state.user.shopId,
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js